import "./ProfilePage.css";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { profileSchema } from "./ProfileValidation";
import { apiRequest } from "services/apiRequest";
import { requestType } from "services/requests";
import { updateDataUser } from "features/auth/authSlice";
import { deleteUser } from 'features/auth/authSlice';

import Navbar from "components/Navbar/Navbar";
import Swal from 'sweetalert2'
import SelectArrow from "assets/images/select_arrow.png";
import Loader from "utilities/reusableComponent/Loader/Loader";

function MyProfile() {

  // get user token from global state
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Profile form initial values
  const initialValues = {
    first_name: userInfo ? userInfo.first_name : '',
    last_name: userInfo ? userInfo.last_name : '',
    email: userInfo ? userInfo.email : '',
    school: userInfo ? userInfo.school_uid : '',
    school_name: userInfo ? userInfo.school_details !== null ? userInfo.school_details.name : userInfo.school : '',
  }

  // Handling on Submit register form
  const onHandleUpdateProfile = async (values) => {
    setLoading(true);
    const profilePayloads = {
      "user_uid": userInfo.uid,
      "first_name": values.first_name,
      "last_name": values.last_name,
      // "email": values.email,
      // "school_uid": values.school,
    };

    const res = await apiRequest({
      requestType: requestType.updateUser,
      payload: {
        data: profilePayloads
      }
    });

    if (res?.data?.status === 0) {
      const userUidPayloads = {
        "user_uid": userInfo.uid,
      }
      dispatch(updateDataUser(userUidPayloads)).then((result) => {
        if(result.payload) {
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
      const swalFailedMessage = Swal.mixin({
        customClass: {
            popup: 'swal-failed-popup',
            confirmButton: "swal-success",
            title: 'swal-title',
        },
        buttonsStyling: false,
      });
      swalFailedMessage.fire({
          title: "Sorry!",
          html: `<p class='swal-text-html'>${res.data.error_message}</p>`,
          imageWidth: 65,
          imageHeight: 60,
          confirmButtonText: "Ok",
      });
    }
  }

  const deleteAccountPopup = () => {
    const swalFailedMessage = Swal.mixin({
        customClass: {
          popup: 'swal-delete-account-popup',
          confirmButton: "swal-delete-account-confirm-btn",
          cancelButton: "swal-delete-account-cancel-btn",
          title: 'swal-title-delete-account',
        },
        buttonsStyling: false,
    });
    swalFailedMessage.fire({
        title: "Are you sure?",
        html: `<p class='swal-text-html'>Deleting your account will mean losing all information associated with your account and it will not be retrievable.</p>`,
        imageWidth: 65,
        imageHeight: 60,
        confirmButtonText: "Yes, Delete My Account",
        cancelButtonText: "No, Go Back",
        reverseButtons: false,
        showCancelButton: true,
        allowOutsideClick: false,
    }).then(async (result) => {
        if (result.isConfirmed) {
            // delete action here.....    
            deleteAccount();
        } 
    });
  }

  const deleteAccount = async() => {
    const payload = {
      "user_uid": userInfo?.uid
    };
    dispatch(deleteUser(payload)).then((result) => {
      if(result.payload.status === 1) {
        // show error message when logout is failed
        const swalFailedMessage = Swal.mixin({
          customClass: {
            popup: 'swal-failed-popup',
            confirmButton: "swal-success",
            title: 'swal-title',
          },
          buttonsStyling: false,
        });
        swalFailedMessage.fire({
          title: "Sorry!",
          html: `<p class='swal-text-html'>${result.payload.error_message}</p>`,
          imageWidth: 65,
          imageHeight: 60,
          confirmButtonText: "Ok",
        });
      
      } else {
        // if delete user success redirect to login page
        navigate("/login");
      }
    });
  }

  return (
    <>        
      <div className="">
        <Navbar />
        <div className="max-w-screen-lg mx-auto">
          <div className="pt-[50px] w-full">
            <h1 className="font-gluten text-custom-navy font-bold text-4xl">
              My Profile
            </h1>
            <div className="flex flex-row gap-10 mt-[40px] h-screen">
              <Formik
                initialValues= {initialValues}
                validationSchema= {profileSchema}
                onSubmit={(values) => onHandleUpdateProfile(values)}
              >
                {({errors, values, handleBlur, handleChange}) => {
                  return (
                  <Form>
                    <div className="w-[1024px] grid grid-cols-2 gap-y-[50px] gap-x-[25px]">
                      <div>
                        <p className="text-xl mb-2">First Name*</p>
                        <Field
                          type="text"
                          name="first_name"
                          placeholder="First Name"
                          className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                        />
                        {errors.first_name && <small className="text-red-500">{errors.first_name}</small>}
                      </div>
                      <div>
                        <p className="text-xl mb-2">Last Name*</p>
                        <Field
                          type="text"
                          name="last_name"
                          placeholder="Last Name"
                          className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                        />
                        {errors.last_name && <small className="text-red-500">{errors.last_name}</small>}
                      </div>
                      <div className="col-span-2">
                        <p className="text-xl mb-2">Email Address*</p>
                        <Field
                          type="email"
                          name="email"
                          disabled={true}
                          placeholder="Email Address"
                          className="rounded-[99px] w-full box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] text-form-color placeholder:text-form-placeholder-color"
                        />
                        {errors.email && <small className="text-red-500">{errors.email}</small>}
                      </div>
                      
                      <div className="col-span-2">
                        <p className="text-xl mb-2">School*</p>
                        <select
                          name="school"
                          value=""
                          onBlur={handleBlur}
                          onChange={handleChange}
                          disabled={true}
                          style={{ "--image-url": `url(${SelectArrow})` }}
                          className="rounded-[99px] w-full  pr-[60px] box-border px-8 py-3 bg-[#f6f6f6] border border-[#e8e8e8] text-[22px] appearance-none bg-[image:var(--image-url)] bg-no-repeat bg-[right_28px_center] bg-[length:10.235px_5.942px]"

                        >
                          <option className="text-form-placeholder-color text-[#e8e8e8]">
                            {values.school_name}
                          </option>    
                        </select>
                        {/* {errors.school && <small className="text-red-500">{errors.school}</small>} */}
                      </div>
                      
                      <div className=" col-span-2 rounded-[67.491px] py-[20px] bg-custom-navy text-white text-base font-bold text-center cursor-pointer">
                        <button type="submit" className="w-full">Save Changes</button>
                      </div>
                      <div className="col-span-2">
                        <div
                          className="flex justify-center w-[500px] rounded-[67.491px] py-[20px] m-auto bg-custom-red text-white text-base font-bold text-center cursor-pointer"
                          onClick={deleteAccountPopup}
                        >
                          Delete Your Account
                        </div>        
                      </div>
                    </div>
                  </Form>
                )}}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </>
  );
}

export default MyProfile;
